"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesPopover = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const attachmentIcon_svg_1 = __importDefault(require("../../../../../assets/icons/attachmentIcon.svg"));
const chevronRight_svg_1 = __importDefault(require("../../../../../assets/icons/chevronRight.svg"));
const dateFormat_1 = require("../../../../../types/dateFormat");
const Typography_1 = require("../../../../atoms/Typography");
const S = __importStar(require("./NotesPopover.style"));
const NotesPopover = ({ notes, initialSlide = 0, open, onOpen, onClose, onSlideChange, }) => {
    const [currentSlide, setCurrentSlide] = (0, react_1.useState)(initialSlide);
    const { t } = (0, react_i18next_1.useTranslation)();
    const isOneNote = notes.length === 1;
    const isMultipleNotes = notes.length > 1;
    const NOTE_CHARACTER_LIMIT = 60;
    // Update currentSlide when initialSlide prop changes
    (0, react_1.useEffect)(() => {
        setCurrentSlide(initialSlide);
    }, [initialSlide]);
    const handlePrevSlide = () => {
        setCurrentSlide((prev) => {
            const newIndex = prev > 0 ? prev - 1 : notes.length - 1;
            if (onSlideChange)
                onSlideChange(notes[newIndex], newIndex);
            return newIndex;
        });
    };
    const handleNextSlide = () => {
        setCurrentSlide((prev) => {
            const newIndex = prev < notes.length - 1 ? prev + 1 : 0;
            if (onSlideChange)
                onSlideChange(notes[newIndex], newIndex);
            return newIndex;
        });
    };
    const handleDotClick = (index) => {
        setCurrentSlide(() => {
            if (onSlideChange)
                onSlideChange(notes[index], index);
            return index;
        });
    };
    return (react_1.default.createElement(S.NoteWrapper, null,
        react_1.default.createElement(S.NotesPopup, { key: `${open ? "open" : "closed"}-${initialSlide}`, open: open, onOpen: onOpen, onClose: onClose, trigger: react_1.default.createElement(S.NoteButton, { "$active": open !== null && open !== void 0 ? open : false },
                react_1.default.createElement(S.NoteButtonIcon, { src: attachmentIcon_svg_1.default, alt: t("map.note.altOpenNote"), "$active": open !== null && open !== void 0 ? open : false })), position: "top center", repositionOnResize: true, keepTooltipInside: true, arrow: false, closeOnDocumentClick: true, offsetX: 10, offsetY: 10 }, notes.length > 0 && (react_1.default.createElement(S.NoteContainer, { "$oneNote": isOneNote },
            isMultipleNotes && (react_1.default.createElement(S.SliderControls, null,
                react_1.default.createElement(S.SliderDots, null, notes.map((_, index) => (react_1.default.createElement(S.SliderDot, { key: index, "$active": index === currentSlide, onClick: () => handleDotClick(index) })))))),
            react_1.default.createElement(S.SlideContainer, null,
                isMultipleNotes && (react_1.default.createElement(S.SliderButton, { onClick: handlePrevSlide },
                    react_1.default.createElement(S.SliderButtonIcon, { src: chevronRight_svg_1.default, alt: t("map.note.altPrevious"), "$left": true }))),
                react_1.default.createElement(S.SlideContent, null,
                    notes[currentSlide].photo && (react_1.default.createElement("a", { href: `${process.env.BASE_URL}${notes[currentSlide].photo}`, target: "_blank" },
                        react_1.default.createElement(S.Photo, { src: `${process.env.BASE_URL}${notes[currentSlide].photoThumbnail}`, alt: t("map.note.altPhoto") }))),
                    react_1.default.createElement(S.DataContainer, null,
                        react_1.default.createElement(S.NoteInfoContainer, null,
                            react_1.default.createElement(Typography_1.H4, { "$bold": true }, t("map.note.date")),
                            react_1.default.createElement(S.NoteDate, null, moment_1.default
                                .utc(notes[currentSlide].date)
                                .format(dateFormat_1.DateFormat.us_with_time))),
                        react_1.default.createElement(S.NoteInfoContainer, null,
                            react_1.default.createElement(Typography_1.H4, { "$bold": true }, t("map.note.note")),
                            react_1.default.createElement(S.NoteTextContainer, { "$isScrollable": notes[currentSlide].text.length > NOTE_CHARACTER_LIMIT },
                                react_1.default.createElement(S.NoteText, null, notes[currentSlide].text))))),
                isMultipleNotes && (react_1.default.createElement(S.SliderButton, { onClick: handleNextSlide },
                    react_1.default.createElement(S.SliderButtonIcon, { src: chevronRight_svg_1.default, alt: t("map.note.altNext") })))))))));
};
exports.NotesPopover = NotesPopover;
